import Plugin0 from '@puntofarma/pss-ai-frontend';
export default [Plugin0];
